export const ENUM_READY_STATE = {
  live: "live",
  ended: "ended",
};

export const DEFAULT_LOVENSE = {
  enable: false,
  tips: {},
  toys: {},
  show: false,
  queue: {
    running: {},
    queue: [],
    waiting: [],
  },
};

export const MOBILE_SIZE = 670;
export const LSM_SIZE = 950;
export const MOBILE_HEADER = 1150;
export const GM_HEADER = 1480;
